import { LeaveRequestTypes } from "@/utils/enums";
import { Badge } from "@/components/ui/badge";
import { type BadgeVariant } from "@/components/ui/badge/badge.variants";

type LeaveRequestType =
  | "annual"
  | "sick"
  | "unpaid"
  | "maternity"
  | "paternity"
  | "bereavement"
  | "other";

const leaveTypeVariant: Record<LeaveRequestType, BadgeVariant> = {
  [LeaveRequestTypes.ANNUAL]:      "success",
  [LeaveRequestTypes.SICK]:        "danger",
  [LeaveRequestTypes.UNPAID]:      "neutral",
  [LeaveRequestTypes.MATERNITY]:   "primary",
  [LeaveRequestTypes.PATERNITY]:   "info",
  [LeaveRequestTypes.BEREAVEMENT]: "primary",
  [LeaveRequestTypes.OTHER]:       "warning",
};

interface IProps {
  type: LeaveRequestType;
}

export const LeaveBadge = ({ type }: IProps) => (
  <Badge variant={leaveTypeVariant[type]}>{type}</Badge>
);
